// import React, { useState } from 'react';
import './ContentBilling.css';

/* -------------------------------------------------
   ⬇️  Put your images/icons inside  public/assets/ …
   CRA / Vite will copy anything in /public as-is,
   so a src="/assets/…" path will resolve correctly.
   ------------------------------------------------- */

const billingIllustration = '/images/content.png';

const services = [
  {
    icon: 'images/tv.svg',
    title: 'Content Delivery',
    description:
      '',
    items: [
      'Our robust Premium SMS Service can be used to provide news alerts, quotes, content like games, videos to users.',

    ]
  },
  {
    icon: 'images/receipt.svg',
    title: 'Content Billing',
    description: '',
    items: [
      'We help you set up Custom subscription &  billing plan tailored to your business model',
    ]
  },
  {
    icon: 'images/pie.svg',
    title: 'Analytics & Insights',
    description: '',
    items: ['We provide Performance dashboards and usage reports so you can track your revenue']
  }
];

const ContentBillingPage = () => {
  // const [email, setEmail] = useState('');

  // const handleSubmit = e => {
  //   e.preventDefault();
  //   // TODO: hook up your submission logic
  //   console.log('Email submitted:', email);
  // };

  return (
    <main className="content-billing-page">
      {/* Hero */}
      <section className="hero-section">
        <h1>Premium SMS</h1>
        <p>
        Deliver and monetize digital content via Premium short codes- available on demand or through subscriptions.
        </p>
      </section>

      {/* Billing Intro */}
      <section className="billing-section">
        <div className="billing-container">
          <div className="billing-image">
            <img src={billingIllustration} alt="Content billing illustration" />
          </div>
          <div className="billing-text">
            <h2>Seamless digital content monetization through carrier billing.</h2>
            <p>
              At Peak Mobile, we make it effortless for customers to purchase digital content
              using their mobile carrier bill. Our advanced technology platforms and deep telco
              integration expertise enable content providers to enhance monetization, extend
              market reach, and drive sustainable growth.
            </p>
            <button className="btn-primary">Contact Us →</button>
          </div>
        </div>
      </section>

      {/* Core Services */}
      <section className="core-services">
        <h2>Features</h2>
        <div className="services-grid">
          {services.map((svc, i) => (
            <div key={i} className="service-card">
              <img src={svc.icon} alt={`${svc.title} icon`} className="service-icon" />
              <h3>{svc.title}</h3>
              {svc.description && <p className="service-desc">{svc.description}</p>}
              {svc.items && (
                <ul className="service-list">
                  {svc.items.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>


    </main>
  );
};

export default ContentBillingPage;
